import React from 'react';
import { styled } from '@compiled/react';
import ExitingPersistence from '@atlaskit/motion/exiting-persistence';
import SlideIn from '@atlaskit/motion/slide-in';
import { Box, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import { MODAL_STATE_IN_PROGRESS } from '../../types';
import ProgressBarIndeterminate from './progress-bar/main.tsx';
import type { Props } from './types';

const InstallationStatusModal = ({
	imageSrc,
	heading,
	description,
	installationState,
	children,
}: Props) => (
	<>
		<StyledHeader>
			<ExitingPersistence appear exitThenEnter>
				<SlideIn enterFrom="right">
					{(props) => (
						<StyledImage
							{...props}
							alt={`Graphic showing the installation status for ${heading}`}
							src={imageSrc}
						/>
					)}
				</SlideIn>
			</ExitingPersistence>
		</StyledHeader>
		<Wrapper>
			<HeadingContainer>
				{installationState === MODAL_STATE_IN_PROGRESS && <ProgressBarIndeterminate />}
				{heading}
			</HeadingContainer>
			<BodyContainer>{description}</BodyContainer>
			<Box xcss={actionsContainerStyles}>{children}</Box>
		</Wrapper>
	</>
);

export default InstallationStatusModal;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const StyledHeader = styled.div({
	padding: 0,
	overflow: 'hidden',
});

/* Constant height for all 3 individual status */
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Wrapper = styled.div({
	textAlign: 'center',
	paddingTop: token('space.200', '16px'),
	height: '180px',
});

/* This height comes from the three images we use for individual status */
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const StyledImage = styled.img({
	width: '100%',
	height: '306px',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const HeadingContainer = styled.h4({
	marginBottom: token('space.300', '24px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const BodyContainer = styled.p({
	marginBottom: token('space.400', '32px'),
});

const actionsContainerStyles = xcss({
	marginBottom: 'space.400',
});
